import { render, staticRenderFns } from "./points-redeem-list.vue?vue&type=template&id=55cca51b&scoped=true&"
import script from "./points-redeem-list.vue?vue&type=script&lang=js&"
export * from "./points-redeem-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cca51b",
  null
  
)

export default component.exports